objectFitImages();

function prepSelects() {
  const selects = $('select');
  selects.each((i, select) => {
    if ($(select).parent().hasClass('v-select')) return;
    $(select).wrap('<span class="v-select">');
  });
}

function hideScrollBar() {
  const scrollTest = $('<div>');
  $('body').append(scrollTest);
  scrollTest.css('width', '100vw');
  const widthWide = scrollTest.outerWidth();
  scrollTest.css('width', '100%');
  const widthSmall = scrollTest.outerWidth();

  const scrollWidth = widthWide - widthSmall;
  scrollTest.remove();

  $('.a-dropform__inner').css('width', `calc(100% + ${scrollWidth}px)`);
}

function useFade(header) {
  return getComputedStyle(header[0]).backgroundColor !== 'rgb(255, 255, 255)';
}

let headerAnimating = 0;
function headerHide(header, scrollTop, dir) {
  if (headerAnimating) return;
  if (scrollTop > 100 && !header.hasClass('header--hidden') && dir === 'down') {
    headerAnimating = 1;
    TweenMax.to(header, .3, {
      yPercent: -100,
      onComplete: () => {
        header.addClass('header--hidden');
        header.removeAttr('style');
        headerAnimating = 0;
      }
    });
  } else if (header.hasClass('header--hidden') && dir === 'up') {
    if (dropFormOpen) return;
    headerAnimating = 1;
    TweenMax.to(header, .3, {
      yPercent: 0,
      onComplete: () => {
        header.removeClass('header--hidden');
        header.removeAttr('style');
        headerAnimating = 0;
      }
    });
  }
}

function initHeaderHide() {
  const header = $('.header');
  let isMobile = useFade(header);

  let headerScrollY = $(window).scrollTop();
  let oldHeaderScrollY = headerScrollY;
  let dir = 'down';

  requestAnimationFrame(() => {
    isMobile = useFade(header);
  });

  $(window).on("resize", () => {
    isMobile = useFade(header);
  });

  $(window).on("scroll", (e) => {
    headerScrollY = $(window).scrollTop();
    dir = headerScrollY > oldHeaderScrollY ? 'down' : 'up';

    if (!isMobile) {
      requestAnimationFrame(() =>
        headerHide(header, headerScrollY, dir)
      );
    }
    oldHeaderScrollY = headerScrollY;
  });
}

function openDropdown(button) {
  dropFormOpen = 1;

  const drop = $('.a-dropform');
  const dropInner = drop.find('.a-dropform__inner');
  const buttonLabel = button.find('.header__form-trigger-label');

  const dropWidth = drop.outerWidth();

  const buttonWidth = button.outerWidth();
  const buttonHeight = button.outerHeight();

  button.css('height', buttonHeight + 'px');

  const overlay = $('.drop-overlay');
  const header = $('.header');
  overlay.addClass('drop-overlay--open');
  header.addClass('header--hidden');

  $('.header__link').fadeOut(200);

  TweenMax.to(button, .25, {
    width: dropWidth,
    backgroundColor: '#30384d',
    ease: 'Quad.easeIn',
    onComplete: () => {
      button.addClass('header__form-trigger--open');

      drop.css('transform', 'scaleY(0)');

      TweenMax.to(drop, .5, {
        scaleY: 1,
        onComplete: () => button.removeAttr('style')
      });

      dropInner.css({
        opacity: 0,
        transform: 'translateY(65px)'
      });

      TweenMax.to(dropInner, .5, {
        y: 0,
        opacity: 1,
        delay: .5,
        onComplete: () => {
          drop.addClass('a-dropform--open');
          dropInner[0].style.transform = '';
          dropInner[0].style.opacity = '';
          drop.removeAttr('style');
        }
      });
    }
  });

  TweenMax.to(buttonLabel, .25, {
    opacity: 0,
    onComplete: () => buttonLabel.removeAttr('style')
  });
}

function closeDropdown() {
  dropFormOpen = 0;

  const drop = $('.a-dropform');
  const dropInner = drop.find('.a-dropform__inner');
  const button = $('.header__form-trigger');
  const buttonLabel = button.find('.header__form-trigger-label');

  const dropWidth = drop.outerWidth();

  const buttonWidth = button.outerWidth();
  const buttonHeight = button.outerHeight();

  $('.header__link').delay(800).fadeIn(200, function(){
    $(this).removeAttr('style');
  });

  button.css({
    width: dropWidth + 'px',
    height: buttonHeight + 'px'
  });

  const overlay = $('.drop-overlay');
  const header = $('.header');
  overlay.removeClass('drop-overlay--open');
  header.removeClass('header--hidden');

  TweenMax.to(dropInner, .5, {
    y: 65,
    opacity: 0,
  });

  TweenMax.to(drop, .5, {
    scaleY: 0,
    delay: .35,
    ease: 'Cubic.easeIn',
    onComplete: () => {
      drop.removeClass('a-dropform--open');
      dropInner[0].style.transform = '';
      dropInner[0].style.opacity = '';
      drop.removeAttr('style');

      TweenMax.to(button, .25, {
        width: buttonWidth,
        backgroundColor: '#4b596d',
        onComplete: () => {
          button.removeClass('header__form-trigger--open');
          button.removeAttr('style');
        }
      });

      TweenMax.to(buttonLabel, .25, {
        opacity: 1,
        onComplete: () => {
          buttonLabel.removeAttr('style');
        }
      });
    }
  });
}

let dropFormOpen = 0;

function mobileOpenDropdown(button) {
  const drop = $('.a-dropform');
  const dropInner = drop.find('.a-dropform__inner');
  const dropHeight = dropInner.outerHeight();
  const header = $('.header');
  const overlay = $('.drop-overlay');

  button.addClass('header__form-trigger--open');

  $('.header__link').css('display', 'none');

  dropFormOpen = 1;

  overlay.css({
    display: 'block',
    opacity: 0
  });

  TweenMax.to(overlay, .5, {
    opacity: 1,
    onComplete: () => {
      overlay.addClass('drop-overlay--open');
      overlay.removeAttr('style');
    }
  });

  TweenMax.to(header, .3, {
    yPercent: -100,
    onComplete: () => {
      header.addClass('header--hidden');
      header.removeAttr('style');
    }
  });

  TweenMax.to(drop, .5, {
    height: dropHeight,
    onComplete: () => {
      drop.addClass('a-dropform--open');
      drop.removeAttr('style');
    }
  });
}

function mobileCloseDropdown(button) {
  const drop = $('.a-dropform');
  const dropInner = drop.find('.a-dropform__inner');
  const dropHeight = dropInner.outerHeight();
  const header = $('.header');
  const overlay = $('.drop-overlay');

  button.removeClass('header__form-trigger--open');

  $('.header__link').removeAttr('style');

  dropFormOpen = 0;

  header.css('transform', 'translateY(-100%)');
  overlay.css('opacity', 1);

  TweenMax.to(overlay, .5, {
    opacity: 0,
    onComplete: () => {
      overlay.removeClass('drop-overlay--open');
      overlay.removeAttr('style');
    }
  });

  TweenMax.to(header, .3, {
    yPercent: 0,
    onComplete: () => {
      header.removeClass('header--hidden');
      header.removeAttr('style');
    }
  });

  TweenMax.to(drop, .5, {
    height: 0,
    onComplete: () => {
      drop.removeClass('a-dropform--open');
      drop.removeAttr('style');
    }
  });
}

function isFormMobile(drop) {
  return getComputedStyle(drop[0]).position === 'relative';
}

$('.header__form-trigger').on('click', function() {
  const form = $('.a-dropform');
  const mobile = isFormMobile(form);
  if ($(this).hasClass('header__form-trigger--open')) {
    if (mobile) {
      mobileCloseDropdown($(this));
    } else {
      closeDropdown($(this));
    }
  } else {
    if (mobile) {
      mobileOpenDropdown($(this));
    } else {
      openDropdown($(this));
    }
  }
});

$('.a-dropform__close').on('click', function(){
  const form = $('.a-dropform');
  const mobile = isFormMobile(form);
  const button = $('.header__form-trigger');

  if (mobile) {
    mobileCloseDropdown(button);
  } else {
    closeDropdown();
  }
});

$('.footer__to-top').on('click', (e) => {
  e.preventDefault();
  TweenMax.to(window, .8, {
    scrollTo: 0,
  });
});




let animController = new ScrollMagic.Controller();
let controllerSet;

function initHeaderTransform() {
  const header = $('.header');
  const link = header.find('.header__link');
  const logoWords = header.find('.header__logo-words');

  const headerTimeline = new TimelineMax();
  const linkBg = TweenMax.to(link, 1, {
    backgroundColor: 'rgba(255, 255, 255, 1)'
  });
  const logoFade = TweenMax.to(logoWords, 1, {
    opacity: 0
  });

  headerTimeline
    .add(linkBg)
    .add(logoFade, 0);

  headerTimeline.play();

  const headerScene = new ScrollMagic.Scene({
    duration: 75,
    offset: 15
  })
  .setTween(headerTimeline)
  .addTo(animController);

  headerScene.on('end', function(e){
    if (e.progress == 1) {
      $('.header__logo').addClass('header__logo--small');
    }
  });

  headerScene.on('enter', function(e){
    if (e.scrollDirection == 'REVERSE') {
      $('.header__logo').removeClass('header__logo--small');
    }
  })
}

function initHeroTransform() {
  const person = $('.m-hero__person');
  const logo = $('.m-hero__background');
  const title = $('.m-hero__text');

  const heroTimeline = new TimelineMax();

  const logoSlide = TweenMax.to(logo, 1, {
    yPercent: -17,
    top: '50vh'
  });

  const personSlide = TweenMax.to(person, 1, {
    yPercent: 100,
  });

  const personFade = TweenMax.to(person, .915, {
    opacity: 0,
    delay: .085
  });

  const titleFade = TweenMax.to(title, .8376, {
    opacity: 0,
    delay: .0405
  });

  heroTimeline
    .add(logoSlide)
    .add(personSlide, 0)
    .add(personFade, 0)
    .add(titleFade, 0);

  const heroScene = new ScrollMagic.Scene({
    duration: 260,
    offset: 0
  })
  .setTween(heroTimeline)
  .addTo(animController);

  $(window).on('resize', () => {
    heroTimeline.progress(0);
    logoSlide.invalidate();

    heroScene.setTween(heroTimeline);
  });
}


function calcHeroHeight() {
  const winHeight = $(window).outerHeight();
  const introHeight = $('.m-intro__content').outerHeight();
  const introTop = $('.m-intro__content').offset().top;
  const heroHeight = $('.m-hero__inner').outerHeight();

  return heroHeight + (winHeight - introHeight) / 2 - (introTop - 260);
}

function initContentTransform() {
  const hero = $('.m-hero');

  const introSlide = TweenMax.to(hero, 1, {
    height: calcHeroHeight()
  });

  const introScene = new ScrollMagic.Scene({
    duration: 219,
    offset: 41
  })
  .setTween(introSlide)
  .addTo(animController);

  introScene.on('leave', (e)=>{
    if (e.state === 'BEFORE') {
      hero.removeAttr('style');
    }
  })

  $(window).on('resize', () => {
    introSlide.progress(0);
    introSlide.invalidate();
    introSlide.updateTo({ css: {
      height: calcHeroHeight()
    }}, true);

    introScene.setTween(introSlide);
  });
}

function initTabsSlide() {
  const section1 = $('.m-tabs__top');
  const section2 = $('.m-tabs__bottom');

  const tabTimeline = new TimelineMax();

  const section1Up = TweenMax.to(section1, .31, {
    y: 0
  });
  const section1Fade = TweenMax.to(section1, .0775, {
    opacity: 1
  });

  const section2Up = TweenMax.to(section2, .625, {
    y: 0,
    delay: .175
  });

  const section2Fade = TweenMax.to(section2, .20625, {
    opacity: 1,
    delay: .175
  });

  tabTimeline
    .add(section1Up)
    .add(section1Fade, 0)
    .add(section2Up, 0)
    .add(section2Fade, 0);

  new ScrollMagic.Scene({
    duration: 400,
    offset: 281
  })
  .setTween(tabTimeline)
  .addTo(animController);
}

$('.m-tabs__nav-link').click(function(e){
  e.preventDefault();
  const target = $(this).attr('href');
  const el = $(target);
  const toggle = $('.m-tabs__accordion[data-filter="' + target + '"]');
  const toggleParent = toggle.parents('.m-tabs__accordion').first();
  const currentEl = $('.m-tabs__tab--active');
  const currentLink = $('.m-tabs__nav-link--active');
  const currentToggle = $('.m-tabs__accordion-toggle--active');
  const currentToggleParent = currentToggle.parents('.m-tabs__accordion').first();

  currentToggle.removeClass('m-tabs__accordion-toggle--open');
  currentToggleParent.removeClass('m-tabs__accordion--open');

  toggle.addClass('m-tabs__accordion-toggle--open');
  toggleParent.addClass('m-tabs__accordion--open');

  currentEl.removeClass('m-tabs__tab--active');
  el.addClass('m-tabs__tab--active');

  currentLink.removeClass('m-tabs__nav-link--active');
  $(this).addClass('m-tabs__nav-link--active');
});

$('.m-tabs__accordion-toggle').click(function(){
  const target = $(this).data('filter');
  const el = $(target);
  const toggle = $(this);
  const toggleParent = $(this).parents('.m-tabs__accordion').first();
  const link = $('.m-tabs__nav-link[href="' + target + '"]');
  const currentEl = $('.m-tabs__tab--active');
  const currentToggle = $('.m-tabs__accordion-toggle--open');
  const currentLink = $('.m-tabs__nav-link--active');
  const currentToggleParent = currentToggle.parents('.m-tabs__accordion').first();

  if (toggle.hasClass('m-tabs__accordion-toggle--open')) {
    currentEl.slideUp(500, function(){
      currentEl.removeAttr('style');

      currentLink.removeClass('m-tabs__nav-link--open');
      currentToggleParent.removeClass('m-tabs__accordion--open');
    });

    currentToggle.removeClass('m-tabs__accordion-toggle--open');
    link.addClass('m-tabs__nav-link--active');

  } else {
    currentEl.slideUp(500, function(){
      currentEl.removeClass('m-tabs__tab--active');
      currentEl.removeAttr('style');
    });

    el.slideDown(500, function(){
      el.addClass('m-tabs__tab--active');
      el.removeAttr('style');

      currentToggleParent.removeClass('m-tabs__accordion--open');
      toggleParent.addClass('m-tabs__accordion--open');
    });

    currentLink.removeClass('m-tabs__nav-link--active');
    link.addClass('m-tabs__nav-link--active');

    currentToggle.removeClass('m-tabs__accordion-toggle--open');
    toggle.addClass('m-tabs__accordion-toggle--open');

  }

});


$(window).on('load', () => {
  prepSelects();
});

function startApp() {
  prepSelects();
  hideScrollBar();
  initHeaderHide();

  initHeaderTransform();
  initHeroTransform();
  initContentTransform();
  initTabsSlide();
}
$(document).ready(startApp);